var _path, _linearGradient, _path2, _path3, _radialGradient, _path4, _path5, _radialGradient2, _path6, _linearGradient2, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRwc2023Logo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 208 220.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M108.7 191.2s55.1-48.8 26.5-167.8c0 0 6.1-2.4 17-4 .1 0 48.4 131.5-43.5 171.8zm4.4-20.1c5.4-18.8 8.3-45.9 8.7-79.7.2-11.2 0-22.7-.5-33.3-11.4 2.1-27.3 24-34.7 55.4-4 17.1-4.7 33.8-2.1 47 2.2 11 6.7 18.4 12 19.6 4.7 1.1 10.7-2.2 16.6-9zm-39.3-61.5c4.4-18.6 11.9-35.3 21-47.3 8.1-10.6 17-16.6 25.6-17.6-.4-6-1-11.5-1.6-16.2C90 37.2 74.2 47.6 74.2 47.6s-1.1 23-1 36.3c.1 9.3.3 17.8.6 25.7zm-5.7 69.7C60 170.1 53 156.9 48.4 142c-4.6-14.8-6.3-29.7-4.7-41.9 1.2-9.2 4.1-16.4 8.6-21 .3-6.7.8-12.9 1.3-18.1l.1-1.6s-12 7.6-22.5 17.2c0 0-1 9-.8 19.7.2 13.9 2.1 27.3 5.6 38.7 4.2 13.4 10.4 25.1 18.6 34.7 12.3 14.4 25.1 19.6 28.4 20.8-4.9-1.9-10-5.7-14.9-11.2z",
    fill: "#2d3cff"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 83.559,
    y1: 37.065,
    x2: 124.022,
    y2: 187.029
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2d3cff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19194b",
    stopOpacity: 0.55
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M108.7 191.2s55.1-48.8 26.5-167.8c0 0 6.1-2.4 17-4 .1 0 48.4 131.5-43.5 171.8zm4.4-20.1c5.4-18.8 8.3-45.9 8.7-79.7.2-11.2 0-22.7-.5-33.3-11.4 2.1-27.3 24-34.7 55.4-4 17.1-4.7 33.8-2.1 47 2.2 11 6.7 18.4 12 19.6 4.7 1.1 10.7-2.2 16.6-9zm-39.3-61.5c4.4-18.6 11.9-35.3 21-47.3 8.1-10.6 17-16.6 25.6-17.6-.4-6-1-11.5-1.6-16.2C90 37.2 74.2 47.6 74.2 47.6s-1.1 23-1 36.3c.1 9.3.3 17.8.6 25.7zm-5.7 69.7C60 170.1 53 156.9 48.4 142c-4.6-14.8-6.3-29.7-4.7-41.9 1.2-9.2 4.1-16.4 8.6-21 .3-6.7.8-12.9 1.3-18.1l.1-1.6s-12 7.6-22.5 17.2c0 0-1 9-.8 19.7.2 13.9 2.1 27.3 5.6 38.7 4.2 13.4 10.4 25.1 18.6 34.7 12.3 14.4 25.1 19.6 28.4 20.8-4.9-1.9-10-5.7-14.9-11.2z",
    fill: "url(#a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1 179.3C60 170.1 53 156.9 48.4 142c-4.6-14.8-6.3-29.7-4.7-41.9 1.2-9.2 4.1-16.4 8.6-21 .3-6.7.8-12.9 1.3-18.1l.1-1.6s-12 7.6-22.5 17.2c0 0-1 9-.8 19.7.2 13.9 2.1 27.3 5.6 38.7 4.2 13.4 10.4 25.1 18.6 34.7 12.3 14.4 25.1 19.6 28.4 20.8-4.9-1.9-10-5.7-14.9-11.2z",
    fill: "none"
  })), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 101.671,
    cy: 54.429,
    r: 17.038,
    gradientTransform: "matrix(.723 -.6909 .3427 .3586 9.515 105.154)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff8366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff3000"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M102.7 186.2c-16.5-2-19-19.6-19.9-30.7-1.1-13.6 1.1-34.3 5.6-48.8 2.5-8.9 5.7-16.9 9.3-23.7 3.6-7.3 8.4-15.2 14.9-23 9.1-10.9 21.7-10.3 29-2.2-.2-1.3-.3-2.6-.5-3.9-3.6-4.6-8.1-7.6-13.2-8.8-10.9-2.5-22.6 3.6-33 17.2-9.4 12.2-16.9 29.3-21.3 48.2-4.4 18.9-5.2 37.6-2.2 52.6 3.4 16.8 11.2 27.5 22.1 30 1.3.3 2.7.5 4 .5 3.8 0 7.4-.9 11.3-2.5.1-.1 2.8-2.5 6.7-7.5-4.1 2.1-8.4 3.2-12.8 2.6z",
    fill: "url(#b)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1 78.9c-3.4 2.5-7.2 7.8-8.4 17.1-1.2 9.1-.4 20 2.1 31.4-1.9-9.3-2.5-18.1-1.5-25.6 1-8 3.8-13.7 7.2-14.8.4-.1.9-.2 1.5-.2 2.1 0 4.6 1.1 7.4 3.2V77.9c-3.2-.8-6.1-.6-8.3 1z",
    fill: "#ff00d2"
  })), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 47.089,
    cy: 86.368,
    r: 14.688,
    fx: 43.339,
    fy: 86.478,
    gradientTransform: "matrix(-.4337 .9011 -.4965 -.2389 110.392 64.575)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff8366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff3000"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7 96.1c1.2-9.3 5-14.7 8.4-17.1 2.3-1.7 5.2-1.8 8.3-.9 0-1.1 0-2.3.1-3.4-4.4-1.6-8.8-1.9-13-.6-9 2.8-15 12-16.7 26.1-1.5 12.2.1 27 4.7 41.9 4.6 14.8 11.6 28.1 19.7 37.2 5 5.7 10.2 9.5 15.4 11.5.7.3 1.4.5 2.2.7.1 0 .3.1.4.1 4.2 1.4 7.9 2.1 11.3 2.1-1.3-.1-2.6-.2-3.9-.5-10.9-2.5-18.7-13.2-22.1-30l-.6-3.6c-3.5-5.9-6.7-13.1-9.3-21.6-1.1-3.5-2-7.1-2.7-10.5-2.7-11.4-3.4-22.3-2.2-31.4z",
    fill: "url(#c)"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: 112.999,
    y1: 186.374,
    x2: 112.999,
    y2: 51.776
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dc0a0a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff00d2"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M141.6 57.8c-7.4-8.1-19.9-8.7-29 2.2-6.5 7.8-11.3 15.7-14.9 23 7.9-15.3 17.6-24.7 24.9-25.1.8 0 1.5 0 2.3.2 5.3 1.2 9.8 8.6 12 19.6 2.6 13.2 1.9 29.9-2.1 47-2.7 11.7-6.6 22.1-11.1 30.6-3.3 6.4-6.9 11.7-10.5 15.8l-.2.2c0 .1-.1.1-.1.2l-.1.1-.4.4-.1.1-.1.1-.1.1-.1.1-.2.2-.1.1-.2.2c-.1.2-.3.3-.4.4-.5.5-1.1 1-1.6 1.5-4.7 4.2-9.2 6.1-12.9 5.3-5.3-1.2-9.8-8.6-12-19.6-2.6-13.2-1.9-29.9 2.1-47 .5-2.3 1.1-4.6 1.7-6.8-4.5 14.5-6.7 35.2-5.6 48.8.9 11.1 3.3 28.6 19.9 30.7 4.5.6 8.8-.5 12.8-2.6 2-2.6 4.3-5.9 6.8-9.9v-.1c.1-.1.1-.2.2-.3 11.8-19.8 26.2-57 19.1-115.5z",
    fill: "url(#d)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRwc2023Logo);
export default __webpack_public_path__ + "static/media/rwc2023logo.3ddcd3b779c5418e2437fa071c254f52.svg";
export { ForwardRef as ReactComponent };